import { render, staticRenderFns } from "./DefaultProfileImage.vue?vue&type=template&id=279a9a06"
import script from "./DefaultProfileImage.vue?vue&type=script&lang=js"
export * from "./DefaultProfileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports